var collection_w16 = collection_w16 || {};

collection_w16.$W = $(window);
collection_w16.$D = $(document);

function library(module) {
    $(function() {
        if (module.init) {
            module.init();
        }
    });
    return module;
}

collection_w16.Menu = library(function() {
    return {
        init: function() {
            collection_w16.$W.load(function(){
                setTimeout(setMenu,10);
            });

            collection_w16.$W.resize(function() {
                setMenu();
            });

            collection_w16.$W.scroll(function() {
                setMenu();
                setHash();
            });

            ancorSlide();
        }
    };

    function setMenu() {
        if (collection_w16.$W.scrollTop() > 130) {
            $('.fixed, .top').addClass('process');
        } else {
            $('.fixed, .top').removeClass('process');
        }
    }

    function setHash() {
        var lastId,
            topMenu = $('.menu'),
        // All list items
            menuItems = $('.menu .js-scroll-link, .scroll-menu-w16 a'),
        // Anchors corresponding to menu items
            scrollItems = menuItems.map(function(){
                var item = $($(this).attr("href"));
                if (item.length) { return item; }
            });

        // Bind to scroll
        collection_w16.$W.on('scroll', function(){
            var winH = collection_w16.$W.height(),
                halfWinH = parseFloat(winH) / 2;

            // Get container scroll position
            var fromTop = $(this).scrollTop()+halfWinH;

            // Get id of current scroll item
            var cur = scrollItems.map(function(){
                if ($(this).offset().top < fromTop)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length-1];
            var id = cur && cur.length ? cur[0].id : "";

            if (id && lastId !== id) {
                lastId = id;
                // Set/remove active class
                menuItems
                    .removeClass("active")
                    .filter("[href=#"+id+"]").addClass("active");
                $('.scroll-menu-w16').attr('data-theme', id);
            }
            if  (collection_w16.$W.scrollTop() == collection_w16.$D.height() - collection_w16.$W.height()) {

                menuItems.removeClass("active");
                $('.scroll-menu-w16 ul').find('li:last-child a').addClass("active");
                $('.menu.coles-smenu ul li:last-child a').addClass("active");
            }
        });
    }

    function ancorSlide() {
        $('.js-scroll-link, .scroll-menu-w16 a').click(function () {
            var $target = $($(this).attr('href')),
                targetOffset = $target.offset().top;

            if(collection_w16.$W.scrollTop() < 130) {
                targetOffset = $target.offset().top-85;
            }

            $('html, body').animate({
                scrollTop: targetOffset
            }, 800);

            return false;
        });
    }
}());

collection_w16.Popup = library(function() {
    return {
        init: function () {
            $('.promo-code').formValidation();

            $('.backstage-w16-table-photo').magnificPopup({
                delegate: 'a',
                type: 'image',
                mainClass: 'mfp-img-mobile mfp-fade',
                gallery: {
                    enabled: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                callbacks: {

                    buildControls: function() {
                        // re-appends controls inside the main container
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                }
            });

            $('.collection-men-w16-table-photo').magnificPopup({
                delegate: 'a',
                type: 'image',
                mainClass: 'mfp-img-mobile mfp-fade',
                gallery: {
                    enabled: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                callbacks: {

                    buildControls: function() {
                        // re-appends controls inside the main container
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },

                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                }
            });

            $('.collection-women-w16-table-photo').magnificPopup({
                delegate: 'a',
                type: 'image',
                mainClass: 'mfp-img-mobile mfp-fade',
                gallery: {
                    enabled: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                callbacks: {

                    buildControls: function() {
                        // re-appends controls inside the main container
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                    }
                },

                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                }
            });

            $('.goods-item--photo').magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                image: {
                    verticalFit: false
                }
            });
        }
    };
}());


$(document).ready(function () {

    // Slick.js
    var initSlick = function (slider, dataArrows) {
        slider.slick({
            infinite: false,
            slide: '.js-slider-item',
            slidesToShow: 4,
            slidesToScroll: 4,
            appendArrows: '.slider-arrows-' + dataArrows,
            prevArrow: '<span class="collection-w16-brands--slider-prev">' +
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
            '<path d="M0.287,8.329 C2.606,10.461 4.925,12.594 7.245,14.725 C8.200,15.603 9.623,14.177 8.665,13.296 C6.600,11.399 4.536,9.502 2.472,7.604 C4.547,5.641 6.621,3.676 8.696,1.711 C9.641,0.817 8.217,-0.609 7.275,0.283 C4.945,2.489 2.616,4.694 0.287,6.900 C-0.099,7.266 -0.109,7.966 0.287,8.329 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
            '</svg>' +
            '</span>',
            nextArrow: '<span class="collection-w16-brands--slider-next">' +
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="9" height="15" viewBox="0 0 9 15">' +
            '<path d="M8.713,6.671 C6.394,4.539 4.075,2.406 1.755,0.275 C0.800,-0.603 -0.623,0.823 0.335,1.704 C2.400,3.601 4.464,5.498 6.528,7.396 C4.453,9.359 2.379,11.324 0.304,13.289 C-0.641,14.183 0.783,15.609 1.725,14.717 C4.055,12.511 6.384,10.306 8.713,8.100 C9.099,7.734 9.109,7.034 8.713,6.671 Z" id="path-1" class="cls-2" fill-rule="evenodd"/>' +
            '</svg>' +
            '</span>',
            //variableWidth: true,
            responsive: [
                {
                    breakpoint: 1248,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1//,
                        //variableWidth: true
                    }
                }
            ]
        });
    };

    $('.js-slick-slider').each(function (i, el) {
        var sl = $(el),
            dataArr = sl.data('arr');

        initSlick(sl, dataArr);
    });

    $(".video-preloader").click(function(){
        var self = $(this),
            html = self.data('video'),
            popup = $('.js-backstage-video-popup');

        popup.find('.js-backstage-video').html(html);
        popup.addClass('_opened');
        //$(this).closest('.collection-backstage-w16-main-item').addClass('_showing-video');
    });

    $('.js-backstage-video-popup').each(function(){
        var self = $(this);

        self.find('.js-backstage-video-close').on('click', function() {
            self.removeClass('_opened');
            self.find('.js-backstage-video').html('');
        });
    });


});
